import MeanChangeAdjData from "./data";

export default function mapMeanChangeAdjData(json) {
    return new MeanChangeAdjData(
        json.refTime,
        json.mean_change_adj,
        json.period
    );
}
